module.exports = __webpack_public_path__ + "2369b2912e9dd9e9b5df692124c0ee65.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/browser/app-store-android.png
// module id = 1008
// module chunks = 25